/*-----------------------------------------------------------------------------/
/ Reservation Notification JS
/-----------------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', function() {
  // Funktionalität für Nutzerbenachrichtigung hinzufügen
  $(document).ajaxComplete(function(event, xhr, settings) {
    // Prüfen, ob es sich um die Reservierungsanfrage handelt
    if (settings.url.includes('reservation-cjf72lxeca-uc.a.run.app')) {
      try {
        const response = JSON.parse(xhr.responseText);
        
        // Wenn der Fehler "already reserved" ist
        if (response.error && response.error.includes("already reserved this product with this email address")) {
          // Ansprechendere Fehlermeldung anzeigen
          $('.red').show().html('<b>Diese E-Mail-Adresse hat dieses Produkt bereits reserviert. Bitte verwenden Sie eine andere E-Mail-Adresse oder warten Sie, bis die vorherige Reservierung abgelaufen ist.</b>');
          
          // Button wieder aktivieren
          $('#reserve2').text('Reservierung abschließen').prop('disabled', false);
        }
      } catch (e) {
        // JSON-Parsing-Fehler ignorieren
        console.error("Fehler beim Parsen der AJAX-Antwort:", e);
      }
    }
  });
});